/**
 * [pug template]
 */
<template lang="pug">
    span.olst-range-component.olst-field-label-subtitle(v-text="rangeHumanized")
</template>
/**
 * [javascript application]
 */
<script>
export default {
  name: 'range-component',
  props: {
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 10
    },
    uom: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {
    rangeHumanized: function () {
      if (this.uom === '') {
        return '(' + this.min + ' - ' + this.max + ')'
      } else {
        return '(' + this.min + ' - ' + this.max + ' ' + this.uom + ')'
      }
    }
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// RangeComponent.vue?2fd99c95